import React from 'react';
import { tierForLevel } from '../../utils/levels';
import './game.css';

export default function RestorationCompleteOverlay({ result, placementTitle, onClose }) {
  if (!result) return null;
  const leveledUp = !!result.xp?.leveledUp;
  const tier = leveledUp ? tierForLevel(result.xp.nextLevel) : null;

  return (
    <div className="discovery-overlay" onClick={onClose}>
      <div className="discovery-card restoration-complete-card" onClick={(e) => e.stopPropagation()}>
        <span className="discovery-eyebrow">Restauración completa</span>
        <div className="restoration-complete-icon">
          <i className="bi bi-patch-check-fill" />
        </div>
        <h3 className="discovery-title">✔ Escultura restaurada: <b>{placementTitle}</b></h3>
        <p className="discovery-sub">
          Explorada desde todos los ángulos. ¡Gran trabajo, restaurador!
        </p>

        {result.teamBonus && (
          <div className="discovery-fragments-hint restoration-team-hint">
            <i className="bi bi-people-fill" />
            ¡Restauración en equipo! Bono extra por explorar junto a otros visitantes.
          </div>
        )}

        {result.xp?.gained ? (
          <span className="discovery-xp-chip">+{result.xp.gained} XP</span>
        ) : null}

        {leveledUp && (
          <div className="discovery-levelup">
            <span className="discovery-levelup-eyebrow">¡Subiste de nivel!</span>
            <strong>Nivel {result.xp.nextLevel} · {tier?.name}</strong>
          </div>
        )}

        <button className="discovery-close-btn" onClick={onClose}>Continuar</button>
      </div>
    </div>
  );
}
